module.exports = __webpack_public_path__ + "static/img/aquaman5_en.941e93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman5_en.png
// module id = MYR1
// module chunks = 1